// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconClock = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path d="M13 11.586V7h-2v5.414l3.793 3.793 1.414-1.414z" />,
    <path fillRule="evenodd" d="M21 12a9 9 0 11-18 0 9 9 0 0118 0m-2 0a7 7 0 11-14 0 7 7 0 0114 0" />
  );
export default SvgIconClock;
